import { useTranslation } from 'react-i18next';
import { ChildBasicDetailsDtoIn } from '@/models/in/ChildBasicDetailsDtoIn';
import { RelationshipStatus } from '@/models/common/RelationshipStatus';
import IconWithText from '@/components/ui/IconWithText/IconWithText';
import approvedSupport from '@/assets/icons/approved-support.svg';
import id2Icon from '@/assets/icons/id2.svg';
import calendar from '@/assets/icons/calendar.svg';
import home from '@/assets/icons/home.svg';

interface ExistingChildrenProps {
  children: ChildBasicDetailsDtoIn[];
}

const ExistingChildren = ({ children }: ExistingChildrenProps) => {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col gap-4">
      <h4 className="body-lr-semibold text-(--font-sub-title-2)">{t('existingChildren')}</h4>

      {!children || children.length === 0 ? (
        <div className="py-4">
          <span className="body-lr-regular text-(--font-body-2)">{t('noChildrenYet')}</span>
        </div>
      ) : (
        <div className="flex flex-col gap-6">
          {children.map((child, index) => (
            <div key={index} className="flex flex-col gap-2">
              <div className="flex gap-2 items-center">
                <div className="h-[15px] border-l-2 border-(--border-tertiary-strong)"></div>
                <span className="body-lr-semibold text-(--font-body-1)">
                  {child.firstName} {child.lastName}
                </span>
              </div>
              <div className="flex flex-col">
                {child.status === RelationshipStatus.Approved ? (
                  <IconWithText icon={approvedSupport} text={t(`childStatus.${child.status}`)} />
                ) : (
                  <div className="flex gap-2 items-center">
                    <span className="body-lr-regular text-(--font-body-1)">{t(`childStatus.${child.status}`)}</span>
                  </div>
                )}
                <IconWithText icon={id2Icon} text={child.israeliId} />
                {child.birthDate && (
                  <IconWithText
                    icon={calendar}
                    text={new Date(child.birthDate).toLocaleDateString('he-IL', {
                      day: '2-digit',
                      month: '2-digit',
                      year: 'numeric',
                    })}
                  />
                )}
                {child.livesWithSupported && <IconWithText icon={home} text={t('livesWithSupported')} />}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default ExistingChildren;
